import React from 'react';

import ThemeTeaser from './Teaser';
import ThemeDetail from './Detail';

const TaxonomyTheme = (props) => {
  const { viewMode } = props;

  if (viewMode === 'teaser') {
    return <ThemeTeaser {...props} />;
  }

  return <ThemeDetail {...props} />;
};

export default TaxonomyTheme;
